import React from 'react';

import PropTypes from 'prop-types';

import { CheckboxRow } from 'components/CheckboxRow/CheckboxRow';

import { BRANCH_TYPE } from 'global/constants';

import { canBranchRenderByStatus } from 'utils/InstallerUtils';

import './AgreementSection.sass';

export const AgreementSection = ({
  energyAgreementLink,
  gasAgreementLink,
  installerStatusSummary,
  formik,
}) => (
  <div className="agreement-section__wrapper">
    {canBranchRenderByStatus(installerStatusSummary, BRANCH_TYPE.ENERGY) && (
      <CheckboxRow
        name="energyAgreement"
        title="Erklärung zur Eintragung in das Elektro-Installateur-Verzeichnis"
        label="Ich verpflichte mich folgendes verbindlich anzuerkennen*:"
        documentLink={energyAgreementLink}
        value={formik.values.energyAgreement}
        onChange={formik.handleChange}
        error={Boolean(formik.errors.energyAgreement)}
      />
    )}
    {canBranchRenderByStatus(installerStatusSummary, BRANCH_TYPE.GAS) && (
      <CheckboxRow
        name="gasAgreement"
        title="Erklärung zur Eintragung in das Gas-Installateur-Verzeichnis"
        label="Ich verpflichte mich folgendes verbindlich anzuerkennen*:"
        documentLink={gasAgreementLink}
        value={formik.values.gasAgreement}
        onChange={formik.handleChange}
        error={Boolean(formik.errors.gasAgreement)}
      />
    )}
  </div>
);
AgreementSection.propTypes = {
  energyAgreementLink: PropTypes.string,
  gasAgreementLink: PropTypes.string,
  installerStatusSummary: PropTypes.object,
  formik: PropTypes.object,
};

AgreementSection.defaultProps = {
  energyAgreementLink: '',
  gasAgreementLink: '',
  installerStatusSummary: {},
  formik: {},
};
